import { Chip, Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { formatTemplateVersion } from './templateLinks'

/**
 * TemplateLinkLabel — story 224 (S103-S105, RN-01.10, H7, H9): "Template: <code> v<version>" with the mark
 * "Deleted version" when the linked version is no longer active. Code and version only — never the template name (H7).
 * Without a link (`{}`) it paints nothing.
 *
 * @param {object} props
 * @param {object} props.link a `TemplateLinkView` (contrato-sun.md §2) or `{}`
 * @param {string} [props.testId]
 */
const TemplateLinkLabel = ({ link = {}, testId = 'workflow-template-link' }) => {
  const { t_ } = useSmartTranslation()
  if (!link.templateCode) {
    return null
  }
  return (
    <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap' useFlexGap data-testid={testId}>
      <Typography variant='body2' color='text.secondary'>
        {t_('Template') + ': ' + link.templateCode + ' v' + formatTemplateVersion(link.templateVersion)}
      </Typography>
      {link.templateVersionActive === false
        ? <Chip size='small' color='warning' variant='outlined' label={t_('Deleted version')} />
        : null}
    </Stack>
  )
}

export default TemplateLinkLabel
